// RequestCard.jsx
import React from "react";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import Colors from "../../../constants/Colors";
import { IconButton } from "@mui/material";
import { Button } from "@mui/material";
import { colors, camelCase } from "../../../constants/constants";
import { useHistory } from "react-router-dom";
import { formatTimestamp, getLatestStatusTimestamp } from '../../../utils/AlertUtilities';
import './NewAlertCard.css'

const NewAlertCard = ({ severity, description, alertObj }) => {
    // let textColor = colors.primaryColor;
    let backgroundColor = colors.primaryColor;
    const history = useHistory();
    
    // Get the most recent status timestamp
    const getMostRecentStatusDate = () => {
        if (!alertObj || !alertObj.statusHistory || alertObj.statusHistory.length === 0) {
            return null;
        }
        
        const latestTimestamp = getLatestStatusTimestamp(alertObj.statusHistory);
        return formatTimestamp(latestTimestamp);
    };

    const recentStatusDate = getMostRecentStatusDate();
    
   switch (severity) {
           case 'CRITICAL':
           case 'Critical':
           case 'High': // Legacy: High maps to CRITICAL (Red)
               backgroundColor = colors.alertBackground; // Red for CRITICAL
               break;
           case 'HIGH':
           case 'High': 
           case 'Low': // Legacy: Low maps to HIGH (Yellow)
               backgroundColor = colors.lowBackground; // Yellow for HIGH
               break;
           case 'POTENTIAL':
           case 'Potential':
           case 'None': // Legacy: None maps to POTENTIAL (Green)
               backgroundColor = colors.greenBackground; // Green for POTENTIAL
               break;
           default:
               backgroundColor = colors.primaryColor;
               break;
       }

    return (
        <div className="card-box" onClick={() => history.push(`/AlertInfo/${alertObj._id}`)}>
            <div className='flex flex-col'>
                {/* Add a red circle */}
                <div className="flex">
                    <Button
                        className='card-button font-bold px-3 py-1'
                        disabled
                        style={{
                            textTransform: 'none',
                            borderRadius: '10px',
                            backgroundColor: backgroundColor,
                            color: 'white',
                            fontWeight: 'bold',
                            width: '7em',
                            fontSize: '16px',
                            opacity: 1,
                        }}
                    >
                        {camelCase(severity)}
                    </Button>
                    <div className="w-8" />
                    <div className='grow flex flex-col justify-center'>
                        <div className='text-xl text-primaryColor description-text'>{description}</div>
                        {recentStatusDate && (
                            <div className='text-sm text-gray-600 mt-1 alert-date-text'>{recentStatusDate}</div>
                        )}
                    </div>
                </div>
            </div>
            <div className='flex items-center'>
                <IconButton onClick={() => history.push(`/AlertInfo/${alertObj._id}`)}>
                    <ArrowForwardIos
                        className="z-0"
                        style={{ color: Colors.primary }}
                    />
                </IconButton>
            </div>
        </div>
    );
}
export default NewAlertCard;